// hooks
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from './../../helpers/BaseError';

// models
import { CreateUserModel } from '../../models/user.model';

// constants
import API from '../../services/api';

const useCreateUserMutation = () => {
    return useMutation<AxiosResponse<any>, BaseError, CreateUserModel>({
        mutationFn: (user: CreateUserModel) => API.createUserFromInvite(user),
    });
};

export default useCreateUserMutation;
